<section class="ui-loading-state" role="status" aria-live="polite">
  <span class="ui-loading-state-spinner" aria-hidden="true"></span>
  <span class="ui-loading-state-copy">
    <span class="ui-loading-state-title">{{ title() }}</span>
    @if (hasDescription()) {
      <span class="ui-loading-state-description">{{ description() }}</span>
    }
  </span>
</section>
